import React from "react";
import "./interactiveDashboards.scss";
import ClickAndFilter from "./sections/clickAndFilter";
import EasiestTool from "./sections/easiestTool";
import FullyInteractive from "./sections/fullyInteractive";
import SmartDashboards from "./sections/smartDashboards";
import Letsgo from "../connectors/letsgo";

function InteractiveDashboards() {
  return (
    <div className="container-interactive-dashboards">
      <div className="section-smart-dashboards">
        <SmartDashboards />
      </div>
      <div className="section-fully-interactive">
        <FullyInteractive />
      </div>
      <div className="section-click-and-filter">
        <ClickAndFilter />
      </div>
      <div className="section-easiest-tool">
        <EasiestTool />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  );
}

export default InteractiveDashboards;
